function setupVenueDirections(root) {
	const dest = root.dataset.destination || '';
	const placeId = root.dataset.placeId || '';
	const cta = root.querySelector('.venue-directions__cta');
	const mapLink = root.querySelector('.venue-directions__maplink');
	const originInput = root.querySelector('.venue-directions__origin-input');
	const locateBtn = root.querySelector('.venue-directions__locate');
	const modeInputs = root.querySelectorAll('input[name="venue-travel-mode"]');

	let mode =
    root.querySelector('input[name="venue-travel-mode"]:checked')?.value ||
    'transit';
	let origin = '';

	function buildHref() {
		const url = new URL('https://www.google.com/maps/dir/');
		url.searchParams.set('api', '1');
		url.searchParams.set('destination', dest);
		if (placeId) {
			url.searchParams.set('destination_place_id', placeId);
		}
		url.searchParams.set('travelmode', mode);
		if (origin) {
			url.searchParams.set('origin', origin);
		}
		return url.toString();
	}

	function updateLinks() {
		const href = buildHref();
		if (cta) {
			cta.href = href;
		}
		if (mapLink) {
			mapLink.href = href;
		}
	}

	// Mode toggles
	modeInputs.forEach((input) => {
		input.addEventListener('change', () => {
			mode = input.value;
			root
				.querySelectorAll('.venue-directions__mode')
				.forEach((label) => label.classList.toggle('is-active', label.contains(input)));
			updateLinks();
		});
	});

	// Origin input
	if (originInput) {
		originInput.addEventListener('input', () => {
			origin = originInput.value.trim();
			updateLinks();
		});
		originInput.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' && cta) {
				window.open(cta.href, '_blank', 'noopener');
			}
		});
	}

	// Geolocate
	if (locateBtn) {
		if ('geolocation' in navigator) {
			locateBtn.addEventListener('click', () => {
				locateBtn.disabled = true;
				navigator.geolocation.getCurrentPosition(
					(pos) => {
						origin = `${pos.coords.latitude},${pos.coords.longitude}`;

						if (originInput) {
							originInput.value = 'Current location';
						}

						updateLinks();
						locateBtn.disabled = false;
					},
					() => {
						locateBtn.disabled = false;
					},
					{ enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
				);
			});
		} else {
			locateBtn.style.display = 'none';
		}
	}

	updateLinks();
}

export function initVenueDirections(scope = document) {
	const widgets = scope.querySelectorAll('.venue-directions');
	widgets.forEach(setupVenueDirections);
}

export default initVenueDirections;
